/* global window */
import { BasePlugin } from '@uppy/core';

const fetchThumbnail = async (file) => {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const video = window.document.createElement('video');
    video.onseeked = () => {
      const canvas = window.document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d').drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
      URL.revokeObjectURL(url);
      const imageDataUrl = canvas.toDataURL('image/jpeg');
      resolve(imageDataUrl);
    };
    video.src = url;
    video.load();
    video.currentTime = 10;
  });
};

class VideoThumbnail extends BasePlugin {
  constructor(uppy, opts) {
    super(uppy, opts);
    this.id = opts.id || 'VideoThumbnail';
    this.type = 'preprocessor';
  }

  updateFileMetadata = async (uppyFile) => {
    const thumbnailUrl = await fetchThumbnail(uppyFile.data);
    this.uppy.setFileState(uppyFile.id, {
      preview: thumbnailUrl
    });
  };

  install() {
    this.uppy.on('file-added', this.updateFileMetadata);
  }

  uninstall() {
    this.uppy.off(this.updateFileMetadata);
  }
}

export default VideoThumbnail;
